import { render } from "./LimitExceededModal.vue?vue&type=template&id=63723fb1&scoped=true"
import script from "./LimitExceededModal.vue?vue&type=script&lang=js"
export * from "./LimitExceededModal.vue?vue&type=script&lang=js"

import "./LimitExceededModal.vue?vue&type=style&index=0&id=63723fb1&scoped=true&lang=css"

import exportComponent from "/tmp/build_5ac5815b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63723fb1"]])

export default __exports__